import { useEffect } from 'react';
import WebSocketService, { NORMAL_CLOSURE } from '../libs/WebSocketService';
import { dispatch } from '../store';
import { addNotification } from '../store/slices/notifications.slice';
import { unmarshall } from '@aws-sdk/util-dynamodb';
import { useContainer } from './useContainer';
import { AppConfig } from '../config/AppConfig';

const useNotificationWebSocket = (userSub: string, accessToken?: string | null) => {
    const webSocketService = useContainer(WebSocketService);

    useEffect(() => {
        if (AppConfig.isWebSocketEnabled) {
            if (userSub && accessToken) webSocketService.connect(userSub, accessToken, pushNotification);

            return () => {
                if (userSub) webSocketService.disconnect(NORMAL_CLOSURE);
            };
        }
    }, [userSub]);

    const pushNotification = (event: MessageEvent) => {
        const parsedData = JSON.parse(event.data);
        if (parsedData.body) {
            const unMarshalledBody = unmarshall(parsedData.body);
            dispatch(addNotification({ ...parsedData, body: unMarshalledBody }));
        }
        dispatch(addNotification({ ...parsedData }));
    };
};

export default useNotificationWebSocket;
